import type { ReactNode } from 'react';
import { EducateNavHeader } from '@/components/brand/EducateNavHeader';
import { CastPanel } from './CastPanel';
import type { CastMember } from '@/types/educate';

interface PlayerScaffoldProps {
  eyebrow: string;
  title: string;
  showLogo?: boolean;
  setting?: string;
  cast?: CastMember[];
  aside?: ReactNode;
  nav: ReactNode;
  footer: ReactNode;
  bodyTestId?: string;
  children: ReactNode;
}

export function PlayerScaffold({
  eyebrow,
  title,
  showLogo = true,
  setting,
  cast,
  aside,
  nav,
  footer,
  bodyTestId,
  children
}: PlayerScaffoldProps) {
  return (
    <EducateNavHeader eyebrow={eyebrow} title={title} showLogo={showLogo}>
      <div className="border-b border-slate-200 bg-white">
        <div className="w-full px-[15%] py-4">
          <div className="flex items-start justify-between gap-4">
            <div className="min-w-0 flex-1">
              <CastPanel setting={setting} cast={cast} />
            </div>
            {aside && <div className="shrink-0">{aside}</div>}
          </div>
          <div className="mt-3">{nav}</div>
        </div>
      </div>

      <main className="w-full flex-1 px-[18%] py-10" data-testid={bodyTestId}>
        {children}
      </main>

      <footer className="sticky bottom-0 border-t border-slate-200 bg-white">
        <div className="flex w-full items-center justify-between gap-4 px-[15%] py-4">{footer}</div>
      </footer>
    </EducateNavHeader>
  );
}

export function PlayerFooter({
  left,
  center,
  right
}: {
  left: ReactNode;
  center: ReactNode;
  right: ReactNode;
}) {
  return (
    <>
      <div className="flex items-center gap-2">{left}</div>
      <p className="flex-1 text-center text-sm font-medium text-slate-500">{center}</p>
      <div className="flex items-center gap-2">{right}</div>
    </>
  );
}
